export const columnCourseCombine = [
  {
    heading: 'Training Recommendation ID',
    props: 'trainingRecommendationID',
    sortable: true,
    active: true,
    disabled: false,
    id: 'trainingRecommendationID'
  },
  {
    heading: 'Course Code',
    props: 'courseCode',
    sortable: true,
    active: true,
    disabled: false,
    id: 'courseCode'
  },
  {
    heading: 'Course Name',
    props: 'courseName',
    sortable: true,
    active: true,
    disabled: false,
    id: 'courseName'
  },
  {
    heading: 'Program Name',
    props: 'courseFrom',
    sortable: true,
    active: true,
    disabled: false,
    id: 'courseFrom'
  },
  {
    heading: 'Year',
    props: 'year',
    sortable: true,
    active: true,
    disabled: false,
    id: 'year'
  },
  {
    heading: 'Action',
    props: 'action',
    sortable: false,
    active: true,
    disabled: false
  }
];
